/** [companyTitle] 在 [states] props 中的 index */
export const index = {
  companyTitle: 0,
};
